/* ------------------------------------------------------------------
   Comportements mobiles de la boutique Moneta.

   Un seul fichier pour trois sujets, chacun dans sa fonction :

   1. tableaux d article        : empilement en cartes
   2. parcours produit          : accord entre le rail et le carrousel
   3. selecteur de taille       : ligne unique, comptage, fondus

   Aucune de ces fonctions ne lit le style calcule de la page entiere.
   Une version precedente parcourait tout le DOM plusieurs fois par
   chargement pour rattraper des animations bloquees ; ce rattrapage a
   ete supprime au profit d une correction a la racine dans
   moneta-home.css, ou le contenu est desormais visible par defaut.
   ------------------------------------------------------------------ */
(function () {
  if (window.__monetaMobile) return;
  window.__monetaMobile = true;

  var MOBILE = '(max-width: 749px)';
  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function visibleText(el) {
    var clone = el.cloneNode(true);
    var hidden = clone.querySelectorAll('.visually-hidden, [hidden]');
    for (var i = 0; i < hidden.length; i++) {
      if (hidden[i].parentNode) hidden[i].parentNode.removeChild(hidden[i]);
    }
    return (clone.textContent || '').replace(/\s+/g, ' ').trim();
  }

  /* =================================================================
     1. TABLEAUX D ARTICLE
     Sur petit ecran un tableau a deux colonnes imposait un defilement
     lateral et coupait la colonne de droite. On empile : chaque ligne
     devient une carte, chaque cellule reprend l intitule de sa colonne.
     Ce script ne pose que les intitules, la mise en forme est en CSS.
     ================================================================= */
  function tables() {
    var list = document.querySelectorAll('.mo-article__body table');
    for (var t = 0; t < list.length; t++) {
      var table = list[t];
      if (table.classList.contains('mo-tb')) continue;

      var headRow = table.querySelector('thead tr');
      var hasThead = !!headRow;
      if (!headRow) headRow = table.querySelector('tr');
      if (!headRow) continue;

      var labels = [];
      for (var i = 0; i < headRow.children.length; i++) labels.push(visibleText(headRow.children[i]));
      if (!hasThead) headRow.classList.add('mo-tb__head');

      var rows = table.querySelectorAll('tr');
      for (var r = 0; r < rows.length; r++) {
        if (rows[r] === headRow) continue;
        for (var c = 0; c < rows[r].children.length; c++) {
          var cell = rows[r].children[c];
          if (labels[c] && !cell.hasAttribute('data-label')) cell.setAttribute('data-label', labels[c]);
        }
      }
      table.classList.add('mo-tb');
    }
  }

  /* =================================================================
     2. PARCOURS PRODUIT
     La mise en diapositives est purement CSS. Ce script ne fait qu une
     chose : tenir le rail et le carrousel d accord.

     La section connait l etape courante et sait peindre le rail, les
     points, le remplissage et l outil. Elle expose trois entrees par
     moneta-parcours-pilote : pcGo, pcStep, pcPause. Une version
     precedente repeignait le rail en parallele depuis la position de
     defilement : les deux se contredisaient, et l outil restait sur
     l etape de la rotation automatique pendant que le lecteur avait
     deja balaye plus loin.

     Deux regimes, jamais melanges :

       tant que personne n a touche
         la rotation commande, la diapositive suit ;
         le parcours se joue tout seul, comme sur grand ecran.

       des le premier geste
         le lecteur commande pour de bon, la rotation est arretee
         sans retour. Une rotation qui reprendrait apres un geste
         viendrait reprendre la page des mains du lecteur toutes les
         six secondes, et redonnerait la desynchronisation qu on
         cherche justement a supprimer.

     On mesure la position reelle de chaque visuel : un calcul largeur
     multipliee par le rang serait fausse par la gouttiere.
     ================================================================= */
  function parcours() {
    if (!window.matchMedia(MOBILE).matches) return;
    var sections = document.querySelectorAll('[id^="pc-"]');

    for (var s = 0; s < sections.length; s++) {
      (function (section) {
        var body = section.querySelector('.pc__body');
        var frames = section.querySelectorAll('.pc__fr');
        if (!body || frames.length < 2) return;
        if (typeof section.pcGo !== 'function') return;
        if (body.dataset.moCarousel === '1') return;
        body.dataset.moCarousel = '1';

        var total = frames.length;

        var hint = document.createElement('p');
        hint.className = 'pc__swipe';
        hint.innerHTML = 'Balayez pour suivre les étapes' + ARROW;
        body.parentNode.insertBefore(hint, body);

        var hintGone = false;
        function dropHint() {
          if (hintGone) return;
          hintGone = true;
          hint.classList.add('is-gone');
        }
        setTimeout(dropHint, 9000);

        /* Position du visuel i par rapport au bord gauche visible. */
        function offsetOf(i) {
          return frames[i].getBoundingClientRect().left - body.getBoundingClientRect().left;
        }

        /* Diapositive la plus proche du bord gauche. */
        function shown() {
          var best = 0, bestDist = Infinity;
          for (var i = 0; i < total; i++) {
            var d = Math.abs(offsetOf(i));
            if (d < bestDist) { bestDist = d; best = i; }
          }
          return best;
        }

        var libre = false;   /* le lecteur a pris la main */
        var pousse = false;  /* deplacement demande par le script */
        var filet = null;
        var repos = null;

        function rendreLaMain() {
          if (libre) return;
          libre = true;
          section.pcPause();
        }

        /* Amene la diapositive i. On affecte la position plutot que
           d appeler scrollBy : le glisse est demande a la feuille de
           style par scroll-behavior, ce qui laisse la decision d animer
           au CSS, avec le repli automatique en mouvement reduit. */
        function amener(i) {
          var d = offsetOf(i);
          if (Math.abs(d) < 2) return;
          pousse = true;
          clearTimeout(filet);
          filet = setTimeout(function () { pousse = false; }, 2000);

          var depart = body.scrollLeft;
          body.scrollLeft += d;

          /* Garde-fou. Un moteur qui n honore pas le glisse laisse la
             position inchangee, sans rien signaler : le rail avancerait
             seul, c est a dire exactement le defaut qu on corrige. Si
             rien n a bouge au bout de 450 ms, on deplace sans
             animation. Le test porte sur le depart du mouvement, pas
             sur son arrivee, pour ne pas couper une animation en cours. */
          setTimeout(function () {
            if (Math.abs(body.scrollLeft - depart) > 2) return;
            var garde = body.style.scrollBehavior;
            body.style.scrollBehavior = 'auto';
            body.scrollLeft = depart + d;
            body.style.scrollBehavior = garde;
          }, 450);
        }

        /* Sens 1 : le geste commande. Le delai laisse le defilement se
           poser, sinon on designerait une etape a chaque image du
           balayage. */
        body.addEventListener('scroll', function () {
          if (body.scrollLeft > 8) dropHint();
          clearTimeout(repos);
          repos = setTimeout(function () {
            if (pousse) { pousse = false; return; }
            rendreLaMain();
            var i = shown();
            if (i !== section.pcStep()) section.pcGo(i);
          }, 130);
        }, { passive: true });

        /* Toucher un point du rail, une etape ou une vignette
           d extremite. La section repeint deja pour les etapes et les
           vignettes, mais pas pour les points ; on appelle pcGo dans
           tous les cas, l appel est sans effet s il ne change rien. */
        section.addEventListener('click', function (e) {
          var el = e.target.closest('[data-pc-dot],[data-pc-step],[data-pc-go]');
          if (!el) return;
          var raw = el.getAttribute('data-pc-dot');
          if (raw === null) raw = el.getAttribute('data-pc-step');
          if (raw === null) raw = el.getAttribute('data-pc-go');
          var i = parseInt(raw, 10);
          if (isNaN(i)) return;
          rendreLaMain();
          section.pcGo(i);
          amener(i);
        });

        /* Sens 2 : la rotation commande, tant que le lecteur n a rien
           touche. La section change une vingtaine de classes par etape ;
           on groupe pour ne mesurer qu une fois par changement d etape.

           Un minuteur et non requestAnimationFrame : dans un onglet
           d arriere-plan celui ci ne se declenche jamais, et le drapeau
           de groupement resterait leve pour de bon, ce qui condamnait
           la synchronisation jusqu au rechargement. */
        var attente = null;
        new MutationObserver(function () {
          if (libre || attente) return;
          attente = setTimeout(function () {
            attente = null;
            var i = section.pcStep();
            if (i !== shown()) amener(i);
          }, 20);
        }).observe(section, { subtree: true, attributes: true, attributeFilter: ['class'] });
      })(sections[s]);
    }
  }

  /* =================================================================
     3. SELECTEUR DE TAILLE
     Dix huit pastilles occupaient trois rangees. On les regroupe dans
     un conteneur qui defile sur une ligne. Le conteneur reste dans le
     fieldset, donc le formulaire et le script de variantes de Shopify
     continuent de fonctionner sans rien savoir du remaniement.
     La ligne unique pouvant faire croire qu il n existe que les tailles
     visibles, on annonce le nombre et l etendue sous la ligne.
     ================================================================= */
  function pluralOf(legend) {
    if (!legend) return '';
    var t = visibleText(legend).toLowerCase().replace(/\s*:\s*$/, '');
    if (!t) return '';
    return /s$/.test(t) ? t : t + 's';
  }

  function buildNote(fs, box) {
    var labels = box.querySelectorAll('label');
    if (labels.length < 4) return null;

    var texts = [];
    for (var i = 0; i < labels.length; i++) texts.push(visibleText(labels[i]));

    var allNumeric = texts.every(function (t) { return /^\d+$/.test(t); });
    var left;
    if (allNumeric) {
      var nums = texts.map(Number);
      left = texts.length + ' ' + pluralOf(fs.querySelector('legend'))
        + ', de ' + Math.min.apply(null, nums) + ' à ' + Math.max.apply(null, nums);
    } else {
      left = texts.length + ' choix';
    }

    var note = document.createElement('p');
    note.className = 'mo-pills__note';
    note.innerHTML = '<span>' + left + '</span><span class="mo-pills__more">Faites glisser' + ARROW + '</span>';
    return note;
  }

  function wirePills(box, note) {
    var more = note ? note.querySelector('.mo-pills__more') : null;
    var moved = false;

    function edges() {
      var max = box.scrollWidth - box.clientWidth;
      var scrollable = max > 4;
      box.classList.toggle('at-start', !scrollable || box.scrollLeft <= 2);
      box.classList.toggle('at-end', !scrollable || box.scrollLeft >= max - 2);
      if (!more) return;
      more.style.display = scrollable ? '' : 'none';
      if (box.scrollLeft > 12) moved = true;
      more.classList.toggle('is-gone', moved);
    }

    var ticking = null;
    box.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = setTimeout(function () { ticking = null; edges(); }, 20);
    }, { passive: true });

    window.addEventListener('resize', edges);
    /* La mise en page n est pas faite au moment du cablage, et les
       polices changent encore la largeur des pastilles apres coup. */
    setTimeout(edges, 0);
    setTimeout(edges, 400);
    setTimeout(edges, 1400);
    window.addEventListener('load', edges);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(edges).catch(function () {});
  }

  function pills() {
    var sets = document.querySelectorAll('.mp .product-form__input--pill');
    for (var s = 0; s < sets.length; s++) {
      var fs = sets[s];
      if (fs.querySelector(':scope > .mo-pills')) continue;

      var box = document.createElement('div');
      box.className = 'mo-pills';

      var movable = [];
      for (var i = 0; i < fs.children.length; i++) {
        if (fs.children[i].tagName !== 'LEGEND') movable.push(fs.children[i]);
      }
      if (!movable.length) continue;
      for (var m = 0; m < movable.length; m++) box.appendChild(movable[m]);
      fs.appendChild(box);

      var note = buildNote(fs, box);
      if (note) fs.appendChild(note);

      /* La taille selectionnee doit etre visible sans avoir a chercher. */
      var checked = box.querySelector('input:checked');
      if (checked && checked.id) {
        var lab = box.querySelector('label[for="' + CSS.escape(checked.id) + '"]');
        if (lab) box.scrollLeft = Math.max(0, lab.offsetLeft - box.clientWidth / 2 + lab.offsetWidth / 2);
      }

      wirePills(box, note);
    }
  }

  /* --- Amorcage ---------------------------------------------------- */
  function init() {
    tables();
    pills();
    parcours();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Shopify redessine le bloc variantes au changement de selection. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name && String(e.target.name).indexOf('options') === 0) setTimeout(pills, 60);
  });

  /* Passage desktop vers mobile sans rechargement. */
  var mq = window.matchMedia(MOBILE);
  if (mq.addEventListener) mq.addEventListener('change', function (e) { if (e.matches) parcours(); });
})();